<template>
  <v-dialog v-model="show" persistent max-width="500px" class="pa-2">
    <!-- PAYMENT -->
    <v-card v-if="type == 'payment' && payment_token">
      <v-card-text class="pa-4">
        <img src="https://x.klarnacdn.net/payment-method/assets/badges/generic/klarna.svg" style="width: 100%; margin: auto" />
        <div id="klarna-payments-container"></div>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-container fluid class="pa-0">
          <v-row align="center">
            <v-col cols="12" sm="4" class="px-3">
              <action-button type="cancel" class="ml-0 d-block" @click="klarna_cancel" large />
            </v-col>
            <v-col cols="12" sm="8" class="px-3 pl-0">
              <action-button type="save" class="ml-0 d-block" @click="payment_authorize" large />
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <!-- CHECKOUT -->
    <v-card v-if="type == 'checkout'">
      <v-card-text class="pa-4">
        <div id="klarna-checkout-container"></div>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-container fluid class="pa-0">
          <v-row align="center">
            <v-col cols="12" sm="12" class="px-3">
              <action-button type="cancel" class="ml-0 d-block" @click="klarna_cancel" large />
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    show: { type: Boolean },
    type: { type: String }, // checkout, payment
    order_data: { type: Object },
    enrolment_ids: { type: Array }
  },
  data() {
    return {
      payment_token: null,
      payment_methods: [],
      payment_method_category: "pay_later",

      checkout_html: null
    }
  },
  created() {},
  watch: {
    show: {
      handler() {
        if (this.show) {
          this.init()
        }
      }
    }
  },
  methods: {
    init() {
      // Create Order
      if (this.type == "payment") {
        this.payment_create_session()
      }

      if (this.type == "checkout") {
        this.checkout_create_order()
      }
    },
    klarna_init() {
      let vm = this

      // Create Klarna script
      let script = document.createElement("script")
      script.setAttribute("src", "https://x.klarnacdn.net/kp/lib/v1/api.js")
      script.async = true
      script.defer = true
      document.head.appendChild(script)

      // Klarna callback
      if (this.type == "payment" && this.payment_token) {
        window.klarnaAsyncCallback = function () {
          window.Klarna.Payments.init({
            client_token: vm.payment_token
          })
          console.log("[Klarna] Init")

          window.Klarna.Payments.load(
            {
              container: "#klarna-payments-container",
              payment_method_category: vm.payment_method_category
            },
            function (res) {
              console.log("[Klarna] Loaded")
              console.log(res)
            }
          )
        }
      }
    },
    payment_create_session() {
      axios
        .post(this.API_URL + "klarna/payment/create-session", {
          order_data: this.order_data
        })
        .then((res) => {
          let status = res.data.status

          if (status == "success") {
            let klarna_json = res.data.klarna
            this.payment_token = klarna_json.client_token
            this.payment_methods = res.data.payment_method_categories
            this.klarna_init()

            console.log("[Klarna - Payment] Create session")
          } else {
            this.klarna_cancel()
          }
        })
    },
    payment_authorize() {
      let vm = this

      window.Klarna.Payments.authorize(
        {
          payment_method_category: vm.payment_method_category
        },
        vm.order_data,
        function (res) {
          console.log("[Klarna] Authorize")
          let approved = res.approved
          let authorization_token = res.authorization_token

          if (approved) {
            axios
              .post(vm.API_URL + "klarna/payment/create-order", {
                authorization_token: authorization_token,
                order_data: vm.order_data
              })
              .then((res) => {
                let status = res.data.status

                if (status == "success") {
                  console.log("[Klarna - Payment] Create order")
                  vm.klarna_success(res.data.klarna)
                } else {
                  vm.klarna_failed(res)
                }
              })
          } else {
            vm.klarna_cancel()
          }
        }
      )
    },
    checkout_create_order() {
      axios
        .post(this.API_URL + "klarna/checkout/create-order", {
          order_data: this.order_data,
          enrolment_ids: this.enrolment_ids
        })
        .then((res) => {
          let status = res.data.status

          if (status == "success") {
            console.log("[Klarna - Checkout] Create order")
            let klarna_json = res.data.klarna
            this.checkout_render_html(klarna_json.html_snippet)
          } else {
            this.klarna_cancel()
          }
        })
    },
    checkout_render_html(htmlSnippet) {
      var checkoutContainer = document.getElementById("klarna-checkout-container")
      checkoutContainer.innerHTML = htmlSnippet
      var scriptsTags = checkoutContainer.getElementsByTagName("script")
      // This is necessary otherwise the scripts tags are not going to be evaluated
      for (var i = 0; i < scriptsTags.length; i++) {
        var parentNode = scriptsTags[i].parentNode
        var newScriptTag = document.createElement("script")
        newScriptTag.type = "text/javascript"
        newScriptTag.text = scriptsTags[i].text
        parentNode.removeChild(scriptsTags[i])
        parentNode.appendChild(newScriptTag)
      }
    },
    klarna_success(obj) {
      console.log("[Klarna] Payment success")
      this.$emit("klarna_success", {
        module: "klarna",
        order_id: obj.order_id
      })
    },
    klarna_failed(obj) {
      console.log("[Klarna] Payment failed")
      this.$emit("klarna_failed", {
        module: "klarna",
        order_id: null,
        error: obj.error.error || null
      })
    },
    klarna_cancel() {
      console.log("[Klarna] Payment cancelled")
      this.payment_token = null
      this.payment_methods = []
      this.$emit("klarna_cancel")
    }
  }
}
</script>
